import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalAirspaceTexts(cal: Calendar) {
  p('initCalAirspaceTexts');

  const calendar = cal;

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-cubes"></i> Napi közlemények'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/airspace_texts.json',
  });
  source.remove();

  let active = !(Cookies.get('cal_no_airspace_texts') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#f2d9de') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_no_airspace_texts', !active + '', {
      expires: 10,
      path: '/'
    });
  }

}